export enum StatusSolicitacaoDotColorEnum {
    'Em_analise' = 'dot-orange',
    'Aprovado' = 'dot-green',
    'Reprovado'= 'dot-red',
    'Cancelado' = 'dot-red'
}